import type { Theme, Components } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Tabs(theme: Theme): Components<Theme> {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          padding: 0,
          fontWeight: theme.typography.fontWeightMedium,
          borderTopLeftRadius: theme.shape.borderRadius,
          borderTopRightRadius: theme.shape.borderRadius,
          flexDirection: "row",
          whiteSpace: "nowrap",
          "&.Mui-selected": {
            color: theme.palette.text.primary,
          },
          "@media (min-width: 600px)": {
            minWidth: 48,
          },
          "&.MuiTab-labelIcon": {
            minHeight: 48,
            flexDirection: "row",
            "& > *:first-of-type": {
              marginBottom: 0,
              marginRight: theme.spacing(1),
            },
          },
          "&.MuiTab-textColorInherit": {
            opacity: 1,
            color: theme.palette.text.secondary,
          },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        scrollButtons: {
          width: 48,
          borderRadius: "50%",
          color: theme.palette.text.primary,
          opacity: 1,
          "&.Mui-disabled": {
            display: "none",
          },
        },
      },
    },
  };
}
